import { ArrowUpRight } from "lucide-react";
import { POLICY_URLS } from "../constants/site";
import "./Footer.css";

const SOCIALS = [
    { label: "Instagram", url: "https://www.instagram.com/thisisgrowco/" },
    { label: "YouTube", url: "https://www.youtube.com/@Thisisgrowco" },
    {
        label: "LinkedIn",
        url: "https://www.linkedin.com/company/growyourcontentwithus/",
    },
];

const POLICIES = [
    { label: "Terms and Conditions", url: POLICY_URLS.terms },
    { label: "Privacy Policy", url: POLICY_URLS.privacy },
    { label: "Refund and Cancellation Policy", url: POLICY_URLS.refund },
    { label: "Digital Services Policy", url: POLICY_URLS.digital },
];

export const Footer = () => {
    const goTop = (e) => {
        e.preventDefault();
        const el = document.getElementById("top");
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el);
        else el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <footer className="footer" data-testid="footer">
            <div className="footer-inner">
                <div className="footer-row-1">
                    <a
                        href="#top"
                        className="navbar-logo"
                        onClick={goTop}
                        data-testid="footer-logo"
                    >
                        <img
                            src="/brand/growco-wordmark.png"
                            alt="GrowCo"
                            className="navbar-logo-img"
                        />
                    </a>
                    <nav className="footer-socials" aria-label="Social">
                        {SOCIALS.map((social) => (
                            <a
                                key={social.label}
                                href={social.url}
                                target="_blank"
                                rel="noopener"
                                className="footer-social-link"
                                data-testid={`footer-social-${social.label.toLowerCase()}`}
                            >
                                {social.label}
                            </a>
                        ))}
                    </nav>
                </div>

                <div className="footer-row-2">
                    <div className="footer-legal">
                        <p data-testid="footer-brand">
                            GrowCo is a brand of Tondku LLP
                        </p>
                        <p>Sector 6, DWARKA, New Delhi 110075</p>
                    </div>
                    <div className="footer-policies">
                        {POLICIES.map((policy) =>
                            policy.url ? (
                                <a
                                    key={policy.label}
                                    href={policy.url}
                                    {...(policy.url.startsWith("/")
                                        ? {}
                                        : { target: "_blank", rel: "noopener" })}
                                    className="footer-policy-link"
                                    data-testid={`footer-policy-${policy.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                >
                                    {policy.label}
                                </a>
                            ) : (
                                <span
                                    key={policy.label}
                                    className="footer-policy-link footer-policy-placeholder"
                                    data-testid={`footer-policy-${policy.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                >
                                    {policy.label} [POLICY_URL]
                                </span>
                            ),
                        )}
                    </div>
                </div>

                <a
                    className="footer-gateway"
                    href="https://growcomotion.com/"
                    target="_blank"
                    rel="noopener"
                    data-testid="footer-gateway-motion"
                >
                    <span className="footer-gateway-text">
                        Looking for animation &amp; motion graphics?
                    </span>
                    <span className="footer-gateway-link">
                        GrowCo Motion
                        <ArrowUpRight
                            size={18}
                            strokeWidth={2}
                            aria-hidden="true"
                        />
                    </span>
                </a>

                <div className="footer-row-3">
                    <p data-testid="footer-copyright">
                        © 2024 Tondku LLP. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};
